import { createAsyncThunk } from "@reduxjs/toolkit";
import { Client } from "@helpers/helpers";
import { API_METHOD } from "@constants/constants";
import { url } from "@constants/url-constants";

export const getMediaList = createAsyncThunk(
  "media/list",
  async ({ pageCount, limit, search, type }) => {

    let query = `?page=${pageCount}&limit=${limit}&deleted_at=1&q=${!search ? "" : search
      }`;

    if (type) {
      query += `&type=${type}`;
    }

    const response = await Client(
      API_METHOD.GET,
      url.mediums + query

    );
    return response.data;
  }
);
export const addMedia = createAsyncThunk(
  "media/add",
  async (data, { rejectWithValue }) => {
    try {
      const response = await Client(API_METHOD.POST, url.mediums, data);
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

//fetch

export const editMedia = createAsyncThunk(
  "media/edit",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await Client(
        API_METHOD.PUT,
        url.mediums + `/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

export const getMediaCount = async () => {
  const response = await Client(API_METHOD.GET, url.mediums)
  return response.data?.data?.item?.total_count;
}

export const getMedia = createAsyncThunk("media/one", async (id) => {
  const response = await Client(API_METHOD.GET, url.mediums + `/${id}`);
  return response.data;
});

export const getPresignedUrl = createAsyncThunk(
  "video-download",
  async ( id ) => {    
    const response = await Client(API_METHOD.GET, `${url.get_presigned_url}/${id}`);
    return response.data;
  }
);
